import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

import "./sentry";
import "imask";
import focus from "@alpinejs/focus";
import mask from "@alpinejs/mask";
import '@alenaksu/json-viewer';

import * as VaporS3 from "./vapor-s3";

import "./alpinejs/components";
import "./alpinejs/store";
import "./lib/clear-errors";
import { timestampFormatter } from "./alpinejs/helpers/data-timestamp";

import "./bootstrap";
import "flatpickr";

import configureMeasurements from 'convert-units';
import allMeasures from 'convert-units/definitions/all';

import './../../vendor/power-components/livewire-powergrid/dist/powergrid'
import './../../vendor/power-components/livewire-powergrid/dist/tailwind.css'

import { livewire_hot_reload } from 'virtual:livewire-hot-reload'

const convert = configureMeasurements(allMeasures);
Alpine.plugin(focus);
Alpine.plugin(mask);

window.VaporS3 = VaporS3;
window.convert = convert;
window.timestampFormatter = timestampFormatter;

Livewire.start()

Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
    window.dispatchEvent(
        new CustomEvent('loading', { detail: { loading: true, componentId: component.__livewireId } })
    );

    succeed(({ snapshot, effect }) => {
        window.dispatchEvent(
            new CustomEvent('loading', { detail: { loading: false, componentId: component.__livewireId } })
        );

        queueMicrotask(() => {
            window.dispatchEvent(
                new CustomEvent('loading', { detail: { loading: false } })
            );
        })
    })

    fail(() => {
        window.dispatchEvent(
            new CustomEvent('loading', { detail: { loading: false, componentId: component.__livewireId } })
        );
    })
})

livewire_hot_reload()
